import React from "react";

import NewInput from "../../../../../shared/forms/NewInput";
import NewHeadline from "../../../../../shared/NewHeadline";
import useAmountStore from "./store";

const Amount = () => {
    const [amount, setAmount, hasErrorAt, addError, clearError] =
        useAmountStore((state) => [
            state.amount,
            state.setAmount,
            state.hasErrorAt,
            state.addError,
            state.clearError,
        ]);

    /**
     * When the amount changes.
     *
     * @param {*} event
     */
    const onChangeAmount = (event) => {
        setAmount(event.target.value);
    };

    return (
        <React.Fragment>
            <NewHeadline>Menge</NewHeadline>
            <NewInput
                type="text"
                placeholder="Menge"
                name="amount"
                onChange={onChangeAmount}
                value={amount}
                validation="hel:amount"
                forceError={hasErrorAt("amount")}
                onError={() => addError("amount")}
                onErrorSolved={() => clearError("amount")}
                withField
            />
        </React.Fragment>
    );
};

export default Amount;
